<template>
    <div class="flex">
      <v-col>
        <v-container fluid class>
          <v-row>
            <v-list dense style="background:transparent;" class="py-0">
              <v-list-item two-line :class="'px-0'">
                <v-card class="pa-4">
                  <v-icon color="primary">{{model.Icon}}</v-icon>
                </v-card>

                <v-list-item-content class="mx-5">
                  <v-list-item-title>
                    <h3>{{evaluateExpression(model.Title)}}</h3>
                  </v-list-item-title>
                  <v-list-item-subtitle>{{evaluateExpression(model.Subtitle)}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-spacer></v-spacer>
            <!-- Actions Menu -->
            <v-menu v-if="isActionsEmpty" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn rounded v-on="on" color="accent">
                  <v-icon>mdi mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in actions"
                  :key="index"
                  @click="onActionclick(item)"
                >
                  <v-list-item-title>{{evaluateExpression(item.Title)}}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-container>
      </v-col>
    </div>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  name: 'dr-content-header-component',
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  computed: {
    isActionsEmpty() {
      return this.model.Actions && this.model.Actions.length > 0
    },
    actions() {
      if (this.model.Actions.length > 2) {
        let actions = this.tryParseActions(this.model.Actions)
        if (Array.isArray(actions)) {
          return actions
        }
        return []
      }
      return []
    }
  },
  methods: {
    onActionclick(item) {
      this.$emit('callDataSourceAction', {
        action: 'contentHeaderItemClick',
        params: item
      })
    },
    tryParseActions(actions) {
      try {
        return JSON.parse(actions)
      } catch (ex) {
        if (ex.name != 'SyntaxError') {
          // eslint-disable-next-line no-console
          console.error(ex)
        }
      }
    }
  }
}
</script>